export enum TemplateFieldGroupEnum {
    GENERAL = 'general',
    UPLOAD = 'upload',
    LEADER = 'leader',
    ABOUT = 'about',
    ASI = 'asi',
    TEAM = 'team',
    PASSPORT = 'passport',
    ORG = 'org',
    ADDITIONAL = 'additional',
}
